"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnergyLabel = exports.ENERGY_LABEL_SIZE = exports.ENERGY_LABEL_RATING = exports.ENERGY_LABEL_RANGE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
require("./EnergyLabel.scss");
var ENERGY_LABEL_SIZE = /*#__PURE__*/function (ENERGY_LABEL_SIZE) {
  ENERGY_LABEL_SIZE["default"] = "default";
  ENERGY_LABEL_SIZE["small"] = "small";
  return ENERGY_LABEL_SIZE;
}(ENERGY_LABEL_SIZE || {});
exports.ENERGY_LABEL_SIZE = ENERGY_LABEL_SIZE;
var ENERGY_LABEL_RANGE = /*#__PURE__*/function (ENERGY_LABEL_RANGE) {
  ENERGY_LABEL_RANGE["newRangeAG"] = "newRangeAG";
  ENERGY_LABEL_RANGE["rangeAPPPG"] = "rangeAPPPG";
  ENERGY_LABEL_RANGE["rangeAPPG"] = "rangeAPPG";
  ENERGY_LABEL_RANGE["rangeAPG"] = "rangeAPG";
  ENERGY_LABEL_RANGE["rangeAG"] = "rangeAG";
  return ENERGY_LABEL_RANGE;
}(ENERGY_LABEL_RANGE || {});
exports.ENERGY_LABEL_RANGE = ENERGY_LABEL_RANGE;
var ENERGY_LABEL_RATING = /*#__PURE__*/function (ENERGY_LABEL_RATING) {
  ENERGY_LABEL_RATING["A+++"] = "A+++";
  ENERGY_LABEL_RATING["A++"] = "A++";
  ENERGY_LABEL_RATING["A+"] = "A+";
  ENERGY_LABEL_RATING["A"] = "A";
  ENERGY_LABEL_RATING["B"] = "B";
  ENERGY_LABEL_RATING["C"] = "C";
  ENERGY_LABEL_RATING["D"] = "D";
  ENERGY_LABEL_RATING["E"] = "E";
  ENERGY_LABEL_RATING["F"] = "F";
  ENERGY_LABEL_RATING["G"] = "G";
  return ENERGY_LABEL_RATING;
}(ENERGY_LABEL_RATING || {});
exports.ENERGY_LABEL_RATING = ENERGY_LABEL_RATING;
var EnergyLabel = function EnergyLabel(_ref) {
  var _classNames;
  var className = _ref.className,
    range = _ref.range,
    rating = _ref.rating,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? ENERGY_LABEL_SIZE["default"] : _ref$size;
  var rootClassName = (0, _classnames["default"])('cds-EnergyLabel', "cds-EnergyLabel--Rating".concat(rating.replace(/\+/g, 'P')), (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "cds-EnergyLabel--".concat((0, _upperCaseFirst.upperCaseFirst)(range || '')), range !== ENERGY_LABEL_RANGE.newRangeAG), (0, _defineProperty2["default"])(_classNames, "cds-EnergyLabel--".concat((0, _upperCaseFirst.upperCaseFirst)(size || '')), size !== ENERGY_LABEL_SIZE["default"]), (0, _defineProperty2["default"])(_classNames, 'cds-EnergyLabel--Eu', range === ENERGY_LABEL_RANGE.newRangeAG), _classNames), className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, range === ENERGY_LABEL_RANGE.newRangeAG && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: "cds-EnergyLabel-Icon",
    name: _Icon.ICON_NAME.rangeEu
  }), rating);
};
exports.EnergyLabel = EnergyLabel;
EnergyLabel.config = {
  size: ENERGY_LABEL_SIZE,
  range: ENERGY_LABEL_RANGE,
  rating: ENERGY_LABEL_RATING
};